var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupplierProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.17 156.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-269.33,425.09-286.13,396l16.21-9.37c4.1-2.37,8.21-4.72,12.29-7.11a10.14,10.14,0,0,1,8.15-1.1c13.89,3.74,27.78,7.43,41.67,11.16a7.21,7.21,0,0,1,5.32,8.79c-1,4-4.62,6.07-8.87,5-10.11-2.6-20.2-5.3-30.31-7.9a4.16,4.16,0,0,0-2.81,0c-.74.45-1.6,1.84-1.38,2.46a4.31,4.31,0,0,0,2.4,2.43c4.58,1.39,9.25,2.51,13.88,3.73,6.73,1.77,13.52,3.34,20.17,5.37A13.3,13.3,0,0,0-198.12,408c10.15-5.95,20.36-11.81,30.55-17.7,5-2.89,10-5.85,15-8.67a8.54,8.54,0,0,1,12.94,6.62c.41,3.84-1.45,6.66-4.78,8.58q-12.31,7.08-24.6,14.22-17.5,10.11-35,20.24a13,13,0,0,1-10.41,1.42c-13.11-3.57-26.29-6.93-39.38-10.59-4.81-1.35-9.18-1.23-13.29,1.78a13.15,13.15,0,0,1-1.55.88C-268.77,424.9-269,425-269.33,425.09Z",
    transform: "translate(323.7 -297.47)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-313.53,396.72c.53.84,1,1.49,1.35,2.16q6.46,11.19,12.92,22.37a13.65,13.65,0,0,0,.94,1.51,2.48,2.48,0,0,0,3.48.75,2.37,2.37,0,0,0,1-3.4c-1-1.87-2.08-3.66-3.13-5.49L-308.9,394c3.19-1.72,6.21-3.53,9.39-5,1.71-.79,3.08.13,4,1.81q11.25,19.59,22.57,39.13c1.12,1.94,2.26,3.85,3.38,5.79,1.36,2.35,1,4-1.28,5.5-1.31.87-2.71,1.62-4.08,2.41-5.12,3-10.23,5.93-15.37,8.86a12.37,12.37,0,0,1-2.88,1.23,2.84,2.84,0,0,1-3.49-1.48q-13.26-23-26.55-45.94a3.08,3.08,0,0,1,1.11-4.46C-319.34,400-316.46,398.45-313.53,396.72Z",
    transform: "translate(323.7 -297.47)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-161.52,380.72l-35.85,20.74-.37-.36a10.08,10.08,0,0,1,1.08-1.66c7.15-7.19,14.26-14.42,21.5-21.5A8.34,8.34,0,0,1-161.52,380.72Z",
    transform: "translate(323.7 -297.47)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-197.39,391.94l-5.53-6.48a113,113,0,0,1,8.22-8.55,8,8,0,0,1,11.34,1.19Z",
    transform: "translate(323.7 -297.47)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-241,326.1l.06.09.06,0Z",
    transform: "translate(323.7 -297.47)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "101.7 41.72 101.7 79.85 67.46 61.54 67.46 23.4 101.7 41.72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-216.84,339.07v.11a.18.18,0,0,1,.08-.15Z",
    transform: "translate(323.7 -297.47)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-216.84,339.07v.11a.18.18,0,0,1,.08-.15Z",
    transform: "translate(323.7 -297.47)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-182.6,320.25v37.69a.16.16,0,0,1-.09.15L-216.59,377a.15.15,0,0,1-.17,0,.15.15,0,0,1-.08-.14V339.18a.18.18,0,0,1,.08-.15l33.54-18.72.06,0,.31-.17a.15.15,0,0,1,.08,0l.09,0A.14.14,0,0,1-182.6,320.25Z",
    transform: "translate(323.7 -297.47)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-219.35,334.57a.18.18,0,0,1-.2,0l-15.9-8.5-.08,0,16,8.57a1.5,1.5,0,0,1,.23-.15Z",
    transform: "translate(323.7 -297.47)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-219.35,334.57a.18.18,0,0,1-.2,0l-15.9-8.5-.08,0,16,8.57a1.5,1.5,0,0,1,.23-.15Z",
    transform: "translate(323.7 -297.47)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-206.8,304.18l-34,19-12.26-6.56a.18.18,0,0,1-.11-.18.18.18,0,0,1,.1-.18l33.63-18.77.1,0a.15.15,0,0,1,.09,0Z",
    transform: "translate(323.7 -297.47)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-185.62,315.62s0,.05,0,.06a.08.08,0,0,1,0,.05s0,0,0,.06l0,0-33.54,18.72-.08,0a.18.18,0,0,1-.2,0l-15.9-8.5,34-19,15.67,8.38A.17.17,0,0,1-185.62,315.62Z",
    transform: "translate(323.7 -297.47)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "82.75 28.72 82.81 28.69 82.88 28.65"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierProducts);
export default __webpack_public_path__ + "static/media/SupplierProducts.0b45626e95278e29d81030a1de677921.svg";
export { ForwardRef as ReactComponent };